import React, { useEffect } from "react";
import AppLoader from "components/AppLoader";
import { useHistory } from "react-router-dom";
import { logout } from "utils/authService";
import { Modal } from "antd";
import { clearTemporarySessionStorage } from 'utils/sessionFilterStoreUtil';

export default function Logout(){
    const history = useHistory();
    
    useEffect(() => {
        function doLogout(){
            logout().then(() => {
                clearTemporarySessionStorage();
                history.replace("/login");
            }, () => {
                Modal.error({
                    title: "Unable to logout!",
                    content: "Try again!",
                    okText: "Logout",
                    onOk: doLogout
                });
            })
        }
        doLogout();
    }, [history])
    return <AppLoader />;
}